import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55c1df30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lecture-info" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lecture-info__title text-gray-600" }, " 课程信息 ", -1))
const _hoisted_3 = {
  key: 0,
  class: "py-3"
}
const _hoisted_4 = {
  key: 1,
  class: "lecture-info__content"
}
const _hoisted_5 = { class: "text-gray-500" }
const _hoisted_6 = { class: "text-gray-500" }
const _hoisted_7 = { class: "text-gray-500" }
const _hoisted_8 = { class: "text-gray-500" }
const _hoisted_9 = { class: "text-gray-500" }
const _hoisted_10 = { class: "text-gray-500" }
const _hoisted_11 = { class: "text-gray-500" }
const _hoisted_12 = { class: "text-gray-500" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_f_skeleton = _resolveComponent("f-skeleton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_f_skeleton)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, "所属模块：" + _toDisplayString(_ctx.lectureInfo.category), 1),
          _createElementVNode("span", _hoisted_6, "学分：" + _toDisplayString(_ctx.lectureInfo.detailInfo.credit), 1),
          _createElementVNode("span", _hoisted_7, "开课院系：" + _toDisplayString(_ctx.lectureInfo.detailInfo.department), 1),
          _createElementVNode("span", _hoisted_8, "校区：" + _toDisplayString(_ctx.lectureInfo.detailInfo.campus), 1),
          (_ctx.isAllLectureInfoVisible)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createElementVNode("span", _hoisted_9, "主讲老师：" + _toDisplayString(_ctx.lectureInfo.taughtBy.join(' ')), 1),
                _createElementVNode("span", _hoisted_10, "考试时间：" + _toDisplayString(_ctx.lectureInfo.detailInfo.examTime), 1),
                _createElementVNode("span", _hoisted_11, "考试形式：" + _toDisplayString(_ctx.lectureInfo.detailInfo.examType), 1),
                _createElementVNode("span", _hoisted_12, "是否允许期中退课：" + _toDisplayString(_ctx.withdrawable), 1)
              ], 64))
            : _createCommentVNode("", true)
        ])),
    (!_ctx.loading && !_ctx.isAllLectureInfoVisible)
      ? (_openBlock(), _createElementBlock("div", {
          key: 2,
          class: "lecture-info__more text-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isAllLectureInfoVisible = true))
        }, " 更多 "))
      : _createCommentVNode("", true)
  ]))
}